import { styled } from '@vw-marketing/us-components';

export const StyledAppContainer = styled.div`
  > div {
    background-color: ${({ theme }) => theme.colors.background.primary};
    display: flex;
    justify-content: center;
  }
`;

